<template>
  <v-container grid-list-xs>
    <v-btn color="success" :to="{ name: 'membership-EditArticle' }">
      {{ $$t('new') }}
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="articles"
      :items-per-page="10"
      class="elevation-1 mt-10"
      sort-by="created"
      :sort-desc="true"
      :loading="isLoading"
    >
      <template v-slot:item.created="{ item }">
        {{ formatDateTime(item.created) }}
      </template>
      <template v-slot:item.isActive="{ item }">
        <BoolField v-model="item.isActive" />
      </template>
      <template v-slot:item.actions="{ item }">
        <TableBasicButtons
          :item="item"
          :editLink="{ name: 'membership-EditArticle', query: { id: item.id } }"
          @delete="DELETE_article(item.id)"
        />
      </template>
    </v-data-table>

    <!-- <v-data-table
      :headers="headers"
      :items="articles"
      :loading="isLoading"
      class="elevation-1 mt-10"
      search="search"
    >
    </v-data-table> -->
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BoolField from '@codehq/aurora-app-core/src/components/BoolField.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import org from '@codehq/aurora-app-core/src/mixins/org';

export default {
  name: 'ListArticles',
  module: 'Membership',
  components: {
    BoolField,
  },
  mixins: [loading, org],
  data() {
    return {
      search: '',
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('articles', ['articles']),
    headers() {
      const { locale } = this.$i18n;
      const postFix = locale.charAt(0).toUpperCase() + locale.slice(1);
      return [{
        text: this.$$t('title'),
        value: `title${postFix}`,
      },
      {
        text: this.$$t('subTitle'),
        value: `subTitle${postFix}`,
      },
      {
        text: this.$$t('created'),
        value: 'created',
      },
      {
        text: this.$$t('isActive'),
        value: 'isActive',
      },
      {
        text: '',
        value: 'actions',
      },
      ];
    },
  },
  async mounted() {
    this.refresh();
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('articles', ['LOAD_articles', 'DELETE_article']),
    async refresh() {
      this.isLoading = true;
      await this.LOAD_articles();
      this.isLoading = false;
    },
  },
};
</script>
